module.exports = __webpack_public_path__ + "static/media/portfoliok2.f59c2b20.png";